import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Leaf, Euro, AlertTriangle } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const API = process.env.REACT_APP_BACKEND_URL;

const eur = (n) => new Intl.NumberFormat("es-ES", { maximumFractionDigits: 0 }).format(Number(n) || 0);
const tons = (n) => new Intl.NumberFormat("es-ES", { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(Number(n) || 0);

// Fix 2026-08-27: Home solo mostraba la inversión I+D — el impacto real de
// Producción (tCO2/€ ahorrados) solo se veía en /impacto. Chips visibles en
// Home leyendo el mismo `/impacto/overview` que la página completa.
export function ImpactoInicioWidget() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const r = await fetch(`${API}/api/impacto/overview`, { headers: { Authorization: `Bearer ${token}` } });
        if (r.ok) {
          const j = await r.json();
          if (!cancel) setData(j?.eficiencias || null);
        }
      } catch { /* silent */ }
    })();
    return () => { cancel = true; };
  }, [token]);

  if (!data || (!data.total_co2_avoided_t && !data.total_annual_savings_eur)) return null;

  return (
    <motion.button
      onClick={() => navigate("/impacto")}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex items-center gap-4 rounded-2xl border bg-gradient-to-br from-emerald-50 to-white dark:from-emerald-950/30 dark:to-slate-900 px-5 py-3 text-left hover:shadow-md transition-shadow"
      data-testid="impacto-inicio-widget"
    >
      <div className="flex items-center gap-2">
        <Leaf className="w-4 h-4 text-emerald-600" />
        <span className="text-lg font-bold text-emerald-700 dark:text-emerald-300" data-testid="impacto-inicio-co2">
          {tons(data.total_co2_avoided_t)} t
        </span>
        <span className="text-xs text-muted-foreground">CO₂ evitadas</span>
      </div>
      <div className="w-px h-6 bg-border" />
      <div className="flex items-center gap-2">
        <Euro className="w-4 h-4 text-blue-600" />
        <span className="text-lg font-bold text-blue-700 dark:text-blue-300" data-testid="impacto-inicio-savings">
          {eur(data.total_annual_savings_eur)} €
        </span>
        <span className="text-xs text-muted-foreground">ahorro anual (Producción)</span>
      </div>
      {data.has_estimado && (
        <span className="flex items-center gap-1 text-[10px] font-semibold text-amber-600 bg-amber-100 dark:bg-amber-950/40 px-1.5 py-0.5 rounded-full" data-testid="impacto-inicio-estimado-badge">
          <AlertTriangle className="w-3 h-3" /> ESTIMADO
        </span>
      )}
    </motion.button>
  );
}
